export const countryLanguageMapV2: Record<
  string,
  { code: string; name: string; countryCode: string }[]
> = {
  gb: [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
  ch: [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
  pt: [
    { code: "pt", name: "Português", countryCode: "pt" },
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
  ],
  it: [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
  es: [
    { code: "es", name: "Español", countryCode: "es" },
    { code: "en", name: "English", countryCode: "gb" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
  fr: [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
  lu: [
    { code: "en", name: "English", countryCode: "gb" },
    { code: "es", name: "Español", countryCode: "es" },
    { code: "pt", name: "Português", countryCode: "pt" },
  ],
};
